@if (isFromModal === false) {
  <div class="ps-3 pe-3 mb-2 mt-2">
    <i-title [text]="text" [buttons]="buttons" level="1"></i-title>
  </div>
}
@if (isFromModal) {
  <i-title [text]="text" [buttons]="buttonsIsFromModal" level="1"></i-title>
}
<div [formGroup]="contactForm" class="form-contact mb" (ngSubmit)="onSubmit()">
  <p-tabView (onChange)="handleChange($event)">
    <p-tabPanel [header]="'information' | translate" leftIcon="bi bi-info-circle">
      <section class="scrollbar-contact container">
        <div class="row mb-2">
          <div class="col-12">
            <label class="super-compos-label-input">{{ 'editCourrier.personType' | translate }}*</label>
            <p-dropdown
              appendTo="body"
              styleClass="w-100"
              [options]="typeSocieteList"
              [placeholder]="'editCourrier.select' | translate"
              formControlName="typeSociete"
              (onChange)="switchToCompany()"
              name="typeSociete"
              id="typeSociete">
            </p-dropdown>
          </div>
        </div>

        @if (!companyMode) {
          <div class="row mb-2">
            <div class="col-4">
              <label class="super-compos-label-input">{{ 'editCourrier.firstName' | translate }}</label>
              <i-input
                [iInput]="{ placeholder: 'editCourrier.firstName' | translate }"
                [type]="'text'"
                [control]="contactForm.get('prenom')"
                [showError]="false"
                styleClass="d-block w-100"></i-input>
            </div>
            <div class="col-4">
              <label class="super-compos-label-input">{{ 'editCourrier.lastName' | translate }}*</label>
              <i-input
                [iInput]="{ placeholder: 'editCourrier.lastName' | translate }"
                [type]="'text'"
                [control]="contactForm.get('nom')"
                [showError]="false"
                styleClass="d-block w-100"></i-input>
              @if (f.nom.invalid) {
                <div class="input-error">{{ 'editCourrier.nameRequired' | translate }}</div>
              }
            </div>
            <div class="col-md-4">
              <label class="super-compos-label-input">{{ 'editCourrier.email' | translate }}</label>
              <i-input
                [iInput]="{ placeholder: 'editCourrier.email' | translate }"
                [type]="'text'"
                [control]="contactForm.get('mail')"
                [showError]="false"
                styleClass="d-block w-100"></i-input>
            </div>
          </div>
        }
        @if (!companyMode) {
          <div class="row mb-2">
            <div class="col-6">
              <label class="super-compos-label-input">{{ 'editCourrier.title' | translate }}</label>
              <p-dropdown
                styleClass="w-100"
                [options]="contactTitles"
                [placeholder]="'editCourrier.select' | translate"
                [showClear]="true"
                formControlName="titre"
                name="titre">
                <ng-template let-item pTemplate="selectedItem"
                  ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
                >
              </p-dropdown>
            </div>
            <div class="col-6">
              <label class="super-compos-label-input">{{ 'editCourrier.language' | translate }}*</label>
              <p-dropdown
                styleClass="w-100"
                [options]="langues"
                [placeholder]="'editCourrier.select' | translate"
                [showClear]="true"
                formControlName="langueId"
                name="langueId">
              </p-dropdown>
              @if (f.langueId.invalid) {
                <div class="input-error">{{ 'editCourrier.languageRequired' | translate }}</div>
              }
            </div>
            <div class="col-6">
              <label class="super-compos-label-input">{{ 'editCourrier.nationalRegistryNumber' | translate }}</label>
              <i-input
                [iInput]="{ placeholder: 'editCourrier.nationalRegistryNumber' | translate }"
                [type]="'text'"
                [control]="contactForm.get('numeroCarteNISS')"
                [showError]="false"
                styleClass="d-block w-100"></i-input>
            </div>
          </div>
        }
        <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$ Company Mode $$$$$$$$$$$$$$$$$$$$$$$$$ -->
        @if (companyMode) {
          <div>
            <div class="row mb-2">
              <div class="col-6">
                <label class="super-compos-label-input">{{ 'editCourrier.lastName' | translate }}*</label>
                <i-input
                  [iInput]="{ placeholder: 'editCourrier.lastName' | translate }"
                  [type]="'text'"
                  [control]="contactForm.get('nom')"
                  [showError]="false"
                  styleClass="d-block w-100"></i-input>
                @if (f.nom.invalid) {
                  <div class="input-error">{{ 'editCourrier.nameRequired' | translate }}</div>
                }
              </div>
              <div class="col-6 p-fluid">
                <label class="super-compos-label-input">{{ 'editCourrier.businessSector' | translate }}</label>
                <p-autoComplete
                  id="secteurActivite"
                  [dropdown]="true"
                  styleClass="w-100"
                  formControlName="secteurActivite"
                  type="search"
                  #Dropdown
                  styleClass="w-100"
                  [suggestions]="filteredSectors | sort: 'label' : 'ASC'"
                  [placeholder]="'editCourrier.select' | translate"
                  dataKey="value"
                  field="label"
                  (completeMethod)="search($event, 'sector')"
                  (onSelect)="onSelectSector($event)">
                </p-autoComplete>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <label class="super-compos-label-input">{{ 'editCourrier.TVA' | translate }}</label>
                <div class="d-flex justify-content-between row">
                  <div class="col-md-4">
                    <p-dropdown
                      [options]="codeTvaList | sort: 'label' : 'ASC'"
                      placeholder="Code Pays"
                      [showClear]="false"
                      appendTo="body"
                      formControlName="tvaPrefix"
                      (onChange)="onTvaCodeChg($event.value)"
                      autocomplete="BE"
                      styleClass="w-100"
                      name="tvaPrefix">
                      <ng-template let-country pTemplate="selectedItem">
                        @if (country.label !== 'AUTRE') {
                          <img src="./assets/img/Flags/{{ country?.label }}.svg" width="25" height="25" class="img-fluid me-2" alt="" />
                        }
                        <span class="ms-2">{{ country?.label }}</span>
                      </ng-template>
                      <ng-template let-country pTemplate="item">
                        <div class="ui-helper-clearfix" style="position: relative; height: 25px">
                          @if (country.label !== 'AUTRE') {
                            <img src="./assets/img/Flags/{{ country?.label }}.svg" width="25" height="25" class="img-fluid me-2" alt="" />
                          }
                          <span class="ms-2">{{ country?.label }}</span>
                        </div>
                      </ng-template>
                    </p-dropdown>
                  </div>
                  <div class="col-md-8">
                    @if (!tvaFrMode) {
                      <p-inputMask
                        formControlName="tva"
                        [autoClear]="false"
                        [mask]="tvaMask"
                        [characterPattern]="tvaRegex"
                        styleClass="super-compos-input-text form-control w-100"
                        [placeholder]="tvaPlaceholder"
                        name="tva">
                      </p-inputMask>
                    }
                    @if (tvaFrMode) {
                      <p-inputMask
                        formControlName="tva"
                        [autoClear]="false"
                        mask="FR-**999999999"
                        styleClass="super-compos-input-text form-control w-100"
                        placeholder="FR-**999999999"
                        [title]="'VATInfo' | translate"
                        name="tvaComplete">
                      </p-inputMask>
                    }
                    @if (f.tva.invalid) {
                      <div class="input-error" placeholder="TVA">{{ 'editCourrier.TVARequired' | translate }}</div>
                    }
                  </div>
                </div>
              </div>
              <div class="col-6">
                <label class="super-compos-label-input">{{ 'editCourrier.legalForm' | translate }}</label>
                <p-dropdown
                  styleClass="w-100"
                  [options]="legalForms | sort: 'label' : 'ASC'"
                  [placeholder]="'editCourrier.select' | translate"
                  [showClear]="true"
                  appendTo="body"
                  formControlName="societeFormeJuridiqueId"
                  name="societeFormeJuridiqueId"></p-dropdown>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <label class="super-compos-label-input">{{ 'editCourrier.BCE' | translate }}</label>
                @if (codePays === 'BE') {
                  <p-inputMask
                    formControlName="bce"
                    [autoClear]="false"
                    [mask]="bceMask"
                    styleClass="super-compos-input-text form-control w-100"
                    [placeholder]="bcePlaceholder"
                    [title]="bceTooltip"
                    name="bce">
                  </p-inputMask>
                }
                @if (codePays !== 'BE') {
                  <i-input
                    [iInput]="{ placeholder: 'Bce' }"
                    [type]="'text'"
                    [control]="contactForm.get('bce')"
                    [showError]="false"
                    styleClass="d-block w-100"></i-input>
                }
              </div>
              <div class="col-6">
                <label class="super-compos-label-input">{{ 'editCourrier.language' | translate }}*</label>
                <p-dropdown
                  styleClass="w-100"
                  [options]="langues | sort: 'label' : 'ASC'"
                  [placeholder]="'editCourrier.select' | translate"
                  [showClear]="true"
                  appendTo="body"
                  formControlName="langueId"
                  name="langueId">
                </p-dropdown>
                @if (f.langueId.invalid) {
                  <div class="input-error">{{ 'editCourrier.languageRequired' | translate }}</div>
                }
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <label class="super-compos-label-input"> {{ 'editCourrier.manager' | translate }} </label>
                <i-input
                  [iInput]="{ placeholder: 'Nom + prénom' }"
                  [type]="'text'"
                  [control]="contactForm.get('gerantSociete')"
                  [showError]="false"
                  styleClass="d-block w-100"></i-input>
              </div>
              <div class="col-md-6 mb-2">
                <label class="super-compos-label-input">{{ 'editCourrier.email' | translate }}</label>
                <i-input
                  [iInput]="{ placeholder: 'editCourrier.email' | translate }"
                  [type]="'text'"
                  [control]="contactForm.get('mail')"
                  [showError]="false"
                  styleClass="d-block w-100"></i-input>
              </div>
            </div>
          </div>
        }
        <div class="form__part2 mb-4">
          <h3 class="super-compos-titre-h3 mt-3">{{ 'editCourrier.contactOptions' | translate }}</h3>
          <div class="row mb-2">
            <div class="col-6">
              <label class="super-compos-label-input"
                >{{ 'editCourrier.contactType' | translate }}
                @if (connectedContactAccessContacts) {
                  <i (click)="openNewTypeContact()" class="bi bi-plus-circle greenIcon clickableIcon"></i>
                }
              </label>
              <p-dropdown
                styleClass="w-100"
                [options]="typeContacts"
                [placeholder]="'editCourrier.select' | translate"
                [showClear]="true"
                [filter]="true"
                appendTo="body"
                formControlName="typeContactId"
                id="dropdownUpdateTypeContactId"></p-dropdown>
            </div>
            <div class="col-6">
              <label class="super-compos-label-input">{{ 'editCourrier.internalName' | translate }}</label>
              <i-input
                [iInput]="{ placeholder: 'editCourrier.internalName' | translate }"
                [type]="'text'"
                [control]="contactForm.get('nomInterne')"
                [showError]="false"
                styleClass="d-block w-100"></i-input>
            </div>
          </div>
        </div>
        <div class="form__part4 mb-3">
          <div class="row mb-3">
            <div class="col-md-12 d-flex align-items-center justify-content-between">
              <h3 class="super-compos-titre-h3 mt-3">{{ 'editCourrier.addresses' | translate }}</h3>
              <i-button [text]="'editCourrier.addAddress' | translate" styleClass="green" size="small" (click)="add()"></i-button>
            </div>
            <div class="col-md-12 mt-2">
              @if (getAdressPrincipal.controls.length === 0) {
                <div class="alert alert-warning" role="alert">{{ 'editCourrier.noAddressEncoded' | translate }}</div>
              }
            </div>
          </div>
          @if (getAdressPrincipal.controls && getAdressPrincipal.controls.length > 0) {
            <div class="form__part4__primary">
              @for (item of getAdressPrincipal.controls; track item; let i = $index) {
                <div formArrayName="listContactsAdresses" name="listContactsAdresses">
                  @if (item.get('toRemove')?.value === false) {
                    <form class="row mb-2 align-content-center" autocomplete="new-password" [formGroupName]="i">
                      <div class="col-md-12 row pe-0 me-0">
                        <div class="col-12 mb-2 pe-0">
                          <label class="super-compos-label-input d-block">{{ 'editCourrier.addressType' | translate }} *</label>
                          <p-dropdown
                            styleClass="w-100"
                            [options]="typesAdresses"
                            [placeholder]="'editCourrier.select' | translate"
                            [showClear]="true"
                            appendTo="body"
                            formControlName="type"
                            id="typeAdd"
                            [disabled]="
                              item.get('type')?.value === 'PRINCIPALE' ||
                              item.get('type')?.value === 'SECONDAIRE' ||
                              item.get('type')?.value === 'PRIVE'
                            "></p-dropdown>
                        </div>
                        <div class="col-md-12 mt-3 mb-2">
                          <h3 class="contact__subtitle">{{ 'editCourrier.structuredAddress' | translate }}</h3>
                        </div>
                        <div class="col-md-3 mb-2 p-fluid">
                          <label class="super-compos-label-input">{{ 'editCourrier.addressCountry' | translate }}</label>
                          <p-dropdown
                            optionLabel="description"
                            optionValue="id"
                            [filter]="true"
                            styleClass="w-100"
                            [options]="countriesList"
                            [placeholder]="'contact.selectCountry' | translate"
                            [showClear]="true"
                            appendTo="body"
                            formControlName="pays"
                            (onChange)="clearZIPAndStreet(i); selectCountry($event)"></p-dropdown>
                        </div>
                        <div class="col-md-3 mb-2 p-fluid">
                          <label class="super-compos-label-input"
                            >{{ 'editCourrier.addressPostalCode' | translate }} - {{ 'editCourrier.addressLocality' | translate }}
                            @if (connectedContactAccessContacts) {
                              <i (click)="openNewPostalCodeModal(i, 'structure')" class="bi bi-plus-circle greenIcon clickableIcon"></i>
                            }
                          </label>
                          <p-autoComplete
                            (onBlur)="leaveInput('cp', i)"
                            id="autocompleteCPUpdateContact{{ i }}"
                            minLength="2"
                            baseZIndex="10"
                            type="search"
                            #Dropdown
                            (onFocus)="focusAutoComplete()"
                            formControlName="structure_LocaliteId"
                            name="structure_LocaliteId"
                            appendTo="body"
                            [suggestions]="filteredPostalCodes"
                            styleClass="w-100"
                            (completeMethod)="search($event, 'postalCode', i)"
                            [showTransitionOptions]="'0ms'"
                            [hideTransitionOptions]="'0ms'"
                            field="autoCompleteField"
                            dataKey="id"
                            placeholder="Code postal - Localité"
                            (onSelect)="selectPostalCode($event, i)"
                            (onClear)="clearStreet(i)">
                          </p-autoComplete>
                        </div>
                        <div class="col-md-3 mb-2 p-fluid">
                          <label class="super-compos-label-input"
                            >{{ 'editCourrier.addressStreet' | translate }}
                            @if (connectedContactAccessContacts) {
                              <i (click)="openNewStreetModal(i, 'structure')" class="bi bi-plus-circle greenIcon clickableIcon"></i>
                            }
                          </label>
                          <p-autoComplete
                            (onBlur)="leaveInput('street', i)"
                            id="autocompleteRueUpdateContact{{ i }}"
                            minLength="3"
                            #DropdownRue
                            type="search"
                            (onFocus)="focusAutoComplete()"
                            formControlName="structure_RueId"
                            [suggestions]="filteredStreets"
                            styleClass="w-100"
                            (completeMethod)="search($event, 'street', i)"
                            field="rueNom"
                            dataKey="id"
                            [placeholder]="'editCourrier.addressStreet' | translate"
                            (onSelect)="selectStreet($event, i)"
                            name="structure_RueId">
                          </p-autoComplete>
                        </div>
                        <div class="col-md-2 mb-2 p-fluid">
                          <label class="super-compos-label-input">{{ 'editCourrier.number' | translate }}</label>
                          <input
                            id="inputNumeroUpdateContact{{ i }}"
                            formControlName="structure_RueNumero"
                            type="search"
                            class="super-compos-input-text form-control w-100"
                            [placeholder]="'editCourrier.number' | translate"
                            autocomplete="new-password" />
                        </div>
                        <div class="col-md-1 mb-2 pe-0 p-fluid">
                          <label class="super-compos-label-input">{{ 'editCourrier.box' | translate }}</label>
                          <input
                            formControlName="structure_RueBoite"
                            type="search"
                            autocomplete="new-password"
                            class="super-compos-input-text form-control w-100"
                            [placeholder]="'editCourrier.box' | translate" />
                        </div>
                        <div class="col-md-12 mt-2 pe-0 mb-2 d-flex align-items-center">
                          <i-button
                            id="impressionAddressContactUpdateButton"
                            text="{{ !listOfDisplayedImpressionAdresses[i] ? 'Afficher' : 'Masquer' }} l'adresse d'impression"
                            styleClass="blue"
                            size="small"
                            (click)="listOfDisplayedImpressionAdresses[i] = !listOfDisplayedImpressionAdresses[i]"></i-button>
                          @if (listOfDisplayedImpressionAdresses[i] === true) {
                            <i-button
                              id="copyImpressionAddressContactUpdateButton"
                              pTooltip="Convertir l'adresse structuré en impression"
                              tooltipPositon="bottom"
                              text="Générer l'adresse d'impression"
                              styleClass="blue ms-3"
                              size="small"
                              (click)="convertImpression(i)"></i-button>
                          }
                        </div>
                        @if (listOfDisplayedImpressionAdresses[i] === true) {
                          <div class="col-md-12 mt-3 mb-2">
                            <h3 class="contact__subtitle" [pTooltip]="'editCourrier.printAddressGenerate' | translate" tooltipPosition="bottom">
                              {{ 'editCourrier.printAddress' | translate }}
                            </h3>
                          </div>
                        }
                        @if (listOfDisplayedImpressionAdresses[i] === true) {
                          <div class="col-md-3 mb-2 p-fluid">
                            <label class="super-compos-label-input">{{ 'editCourrier.addressCountry' | translate }}</label>
                            <input
                              id="impressionPaysContactUpdateInput"
                              type="search"
                              autocomplete="new-password"
                              pInputText
                              formControlName="impression_Pays"
                              class="super-compos-input-text form-control w-100"
                              [placeholder]="'editCourrier.addressCountry' | translate" />
                          </div>
                        }
                        @if (listOfDisplayedImpressionAdresses[i] === true) {
                          <div class="col-md-3 mb-2 p-fluid">
                            <label class="super-compos-label-input"
                              >{{ 'editCourrier.addressPostalCode' | translate }}
                              @if (connectedContactAccessContacts) {
                                <i (click)="openNewPostalCodeModal(i, 'impression')" class="bi bi-plus-circle greenIcon clickableIcon"></i>
                              }
                            </label>
                            <input
                              id="impressionCodePostalContactUpdateInput"
                              type="search"
                              autocomplete="new-password"
                              pInputText
                              formControlName="impression_CodePostal"
                              class="super-compos-input-text form-control w-100"
                              [placeholder]="'editCourrier.addressPostalCode' | translate" />
                          </div>
                        }
                        @if (listOfDisplayedImpressionAdresses[i] === true) {
                          <div class="col-md-3 mb-2 p-fluid">
                            <label class="super-compos-label-input"
                              >{{ 'editCourrier.addressLocality' | translate }}
                              @if (connectedContactAccessContacts) {
                                <i (click)="openNewPostalCodeModal(i, 'impression')" class="bi bi-plus-circle greenIcon clickableIcon"></i>
                              }
                            </label>
                            <input
                              id="impressionLocaliteContactUpdateInput"
                              type="search"
                              autocomplete="new-password"
                              pInputText
                              formControlName="impression_Localite"
                              class="super-compos-input-text form-control w-100"
                              [placeholder]="'editCourrier.addressLocality' | translate" />
                          </div>
                        }
                        @if (listOfDisplayedImpressionAdresses[i] === true) {
                          <div class="col-md-3 mb-2 p-fluid">
                            <label class="super-compos-label-input"
                              >{{ 'editCourrier.addressStreet' | translate }}
                              @if (connectedContactAccessContacts) {
                                <i (click)="openNewStreetModal(i, 'impression')" class="bi bi-plus-circle greenIcon clickableIcon"></i>
                              }
                            </label>
                            <textarea
                              id="impressionRueContactUpdateTextarea"
                              pInputText
                              formControlName="impression_Adresse"
                              type="search"
                              autocomplete="new-password"
                              class="super-compos-input-text form-control w-100"
                              [placeholder]="'editCourrier.addressStreet' | translate"></textarea>
                          </div>
                        }
                        <div class="col-md-12 mt-3 mb-2">
                          <h3 class="contact__subtitle">{{ 'editCourrier.information' | translate }}</h3>
                        </div>
                        <div class="col-md-2 mb-2 p-fluid">
                          <label class="super-compos-label-input d-block">{{ 'editCourrier.countryCode' | translate }}</label>
                          <p-dropdown
                            class="dropdown-inforius"
                            [options]="codeTvaList | sort: 'label' : 'ASC'"
                            [placeholder]="'editCourrier.countryCode' | translate"
                            [showClear]="false"
                            appendTo="body"
                            (onChange)="onCountryChange($event.value)"
                            autocomplete="BE">
                            <ng-template let-country pTemplate="selectedItem">
                              @if (country.label !== 'AUTRE') {
                                <img src="./assets/img/Flags/{{ country?.label }}.svg" width="25" height="25" class="img-fluid me-2" alt="" />
                              }
                              <span class="ms-2">{{ country?.label }}</span>
                            </ng-template>
                            <ng-template let-country pTemplate="item">
                              <div class="ui-helper-clearfix" style="position: relative; height: 25px">
                                @if (country.label !== 'AUTRE') {
                                  <img src="./assets/img/Flags/{{ country?.label }}.svg" width="25" height="25" class="img-fluid me-2" alt="" />
                                }
                                <span class="ms-2">{{ country?.label }}</span>
                              </div>
                            </ng-template>
                          </p-dropdown>
                        </div>
                        <div class="col-md-3 mb-2 p-fluid">
                          <label class="super-compos-label-input d-block">{{ clientType === 'JVS' ? 'Tel. portable' : 'GSM' }}</label>
                          @if (prefixNumber) {
                            <p-inputMask
                              appendTo="body"
                              styleClass="w-100 form-control"
                              formControlName="gsm"
                              mask="{{ prefixNumber }} 999 99 99 99"
                              name="gsm"
                              id="gsmInput"
                              [autoClear]="false"></p-inputMask>
                          }
                          @if (!prefixNumber) {
                            <input
                              type="number"
                              formControlName="gsm"
                              autocomplete="new-password"
                              class="noArrow super-compos-input-text form-control w-100"
                              name="gsm"
                              id="gsmInput" />
                          }
                        </div>
                        <div class="col-3 mb-2 p-fluid">
                          <label class="super-compos-label-input">{{ 'editCourrier.telephone' | translate }}</label>
                          <input
                            formControlName="telephone"
                            autocomplete="new-password"
                            type="text"
                            class="super-compos-input-text form-control w-100"
                            name="telephone" />
                        </div>
                        @if (i !== 0) {
                          <div class="col-4 mb-2 p-fluid">
                            <label class="super-compos-label-input">{{ 'editCourrier.email' | translate }}</label>
                            <input
                              (input)="checkEmailPattern(i)"
                              formControlName="mail"
                              autocomplete="new-password"
                              class="w-100 super-compos-input-text form-control"
                              [placeholder]="'editCourrier.email' | translate"
                              name="mail" />
                            @if (!checkEmailPattern(i)) {
                              <div class="input-error">{{ 'editCourrier.incorrectAddressFormat' | translate }}</div>
                            }
                          </div>
                        }
                        <div class="col-6 mb-2 p-fluid">
                          <label class="super-compos-label-input">{{ 'editCourrier.fax' | translate }}</label>
                          <input
                            formControlName="fax"
                            autocomplete="new-password"
                            type="phone"
                            class="super-compos-input-text form-control w-100"
                            [placeholder]="'editCourrier.fax' | translate"
                            name="fax" />
                        </div>
                        <div class="col-6 mb-2 p-fluid">
                          <label class="super-compos-label-input">{{ 'editCourrier.website' | translate }}</label>
                          <input
                            formControlName="site"
                            autocomplete="new-password"
                            type="text"
                            class="super-compos-input-text form-control w-100"
                            name="site"
                            [placeholder]="'editCourrier.website' | translate" />
                        </div>
                      </div>
                      <div class="col-md-12 mt-2 mb-4">
                        <i-button
                          text="Supprimer l'adresse"
                          styleClass="red d-inline-block"
                          size="small"
                          class="d-inline-block"
                          (click)="remove(i)"
                          name="deleteAddress">
                          {{ 'delete' | translate }}</i-button
                        >
                      </div>
                    </form>
                  }
                </div>
              }
            </div>
          }
        </div>
        <!--  $$$ End Adress switch $$$ -->
        <!-- $$$$$$ShowMore$$$$$$$$$$$$ -->
        <div class="form__showMore">
          <div class="d-flex justify-content-center">
            @if (!fullMode) {
              <i-button
                [text]="'editCourrier.showAdditionalInformation' | translate"
                (click)="showMore()"
                styleClass="blue showMoreBtn mb-5"
                icon="bi bi-zoom-in"
                id="showMoreDetailsContact">
              </i-button>
            }
            @if (fullMode) {
              <i-button
                [text]="'editCourrier.hideAdditionalInformation' | translate"
                (click)="showMore()"
                styleClass="blue showMoreBtn mb-5"
                icon="bi bi-zoom-out"
                id="showMoreDetailsContact">
              </i-button>
            }
          </div>

          @if (fullMode) {
            <div>
              <div class="row mb-3">
                <div class="col-md-12">
                  <h3 class="super-compos-titre-h3 mt-3">{{ 'editCourrier.additionalInfo' | translate }}</h3>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <label class="super-compos-label-input">{{ 'editCourrier.website' | translate }}</label>
                  <i-input
                    [iInput]="{ placeholder: 'editCourrier.website' | translate }"
                    [type]="'text'"
                    [control]="contactForm.get('siteWeb')"
                    styleClass="d-block w-100"></i-input>
                </div>
              </div>
              @if (!companyMode) {
                <div class="row mb-2">
                  <div class="col-6">
                    <label class="super-compos-label-input">{{ 'editCourrier.birthdate' | translate }}</label>
                    @if (locale4Calendar) {
                      <p-calendar
                        [defaultDate]="datebirthdefault"
                        [locale]="locale4Calendar"
                        [firstDayOfWeek]="1"
                        appendTo="body"
                        formControlName="dateNaissance"
                        [showIcon]="true"
                        [iconDisplay]="'input'"
                        dateFormat="dd/mm/yy"
                        [placeholder]="'editCourrier.birthdate' | translate"
                        [yearRange]="yearRange">
                      </p-calendar>
                    }
                  </div>
                  <div class="col-6">
                    <label class="super-compos-label-input">{{ 'editCourrier.birthplace' | translate }}</label>
                    <i-input
                      [iInput]="{ placeholder: 'editCourrier.birthplace' | translate }"
                      [type]="'text'"
                      [control]="contactForm.get('naissanceLieu')"
                      [showError]="false"
                      styleClass="d-block w-100"></i-input>
                  </div>
                </div>
              }
              @if (!companyMode) {
                <div class="row mb-2">
                  <div class="col-6">
                    <label class="super-compos-label-input">{{ 'editCourrier.maritalStatus' | translate }}</label>
                    <p-dropdown
                      styleClass="w-100"
                      [options]="etatCivils | sort: 'label' : 'ASC'"
                      [placeholder]="'editCourrier.select' | translate"
                      [showClear]="true"
                      appendTo="body"
                      formControlName="etatCivil"
                      name="etatCivil"></p-dropdown>
                  </div>
                  <div class="col-6">
                    <label class="super-compos-label-input">{{ 'editCourrier.gender' | translate }}</label>
                    <p-dropdown
                      styleClass="w-100"
                      [options]="sexes | sort: 'label' : 'ASC'"
                      [placeholder]="'editCourrier.select' | translate"
                      [showClear]="true"
                      appendTo="body"
                      formControlName="sexe"
                      name="sexe">
                    </p-dropdown>
                  </div>
                </div>
              }
              @if (!companyMode) {
                <div class="row mb-2">
                  <div class="col-6">
                    <label class="super-compos-label-input">{{ 'editCourrier.nationality' | translate }}</label>
                    <p-dropdown
                      styleClass="w-100"
                      [options]="nationalites | sort: 'label' : 'ASC'"
                      [placeholder]="'editCourrier.select' | translate"
                      [showClear]="true"
                      appendTo="body"
                      formControlName="nationalite"
                      name="nationalite"></p-dropdown>
                  </div>
                </div>
              }
              <div class="row mb-2">
                <div class="col-12">
                  <label class="super-compos-label-input">{{ 'editCourrier.remarks' | translate }}</label>
                  <textarea id="float" class="w-100" pInputTextarea [rows]="3" formControlName="commentaires" name="commentaires"></textarea>
                </div>
              </div>
            </div>
          }
        </div>
      </section>
    </p-tabPanel>

    @if (!companyMode) {
      <p-tabPanel
        [header]="'Société(s) liée(s)  ' + liensSocSoc.length"
        leftIcon="bi bi-building"
        [tooltip]="tooltipSociety"
        [disabled]="contact?.typeSociete === true">
        @if (activeIndex === 1) {
          <app-contact-company-linked [contact]="contact" (memberLinkCount)="receiveSocCount($event)" (editEnabled)="receiveEditEnabled($event)">
          </app-contact-company-linked>
        }
      </p-tabPanel>
    }
  </p-tabView>

  <p-confirmDialog
    key="confirmContact"
    baseZIndex="1000"
    #cd
    appendTo="body"
    styleClass="super-compos-modal-content confirmModal"
    [header]="'modals.confirmation' | translate"
    icon="bi bi-exclamation-triangle">
    <p-footer>
      <button type="button" pButton icon="pi pi-times" label="Non" (click)="cd.reject()"></button>
      <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="cd.accept()"></button>
    </p-footer>
  </p-confirmDialog>
</div>

<p-dialog styleClass="super-compos-modal-content" [(visible)]="showCreateCP" [modal]="true" appendTo="body" [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'editCourrier.postalCodeManagement' | translate }}</h5>
      <div class="d-flex">
        <i-button styleClass="blue" (click)="showCreateCP = false" [text]="'cancel' | translate"></i-button>
        <i-button styleClass="green ms-3" [disabled]="!formCP.valid" (click)="submitNewCP()" [text]="'confirm' | translate"></i-button>
      </div>
    </div>
  </p-header>
  <form [formGroup]="formCP" class="mt-3 mb-3 row">
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'editCourrier.country' | translate }}</label>
      <p-dropdown
        styleClass="w-100"
        [virtualScroll]="true"
        virtualScrollItemSize="30"
        appendTo="body"
        [options]="countries"
        [filter]="true"
        [placeholder]="'editCourrier.select' | translate"
        [showClear]="true"
        formControlName="paysID">
      </p-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'editCourrier.postalCode' | translate }}*</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: 4000' }"
        [type]="'text'"
        [control]="formCP.get('codePostal')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'editCourrier.locality' | translate }}</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: 1' }"
        [type]="'text'"
        [control]="formCP.get('localite')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'editCourrier.language' | translate }}</label>
      <p-dropdown
        styleClass="w-100"
        [virtualScroll]="true"
        virtualScrollItemSize="30"
        appendTo="body"
        [options]="langues"
        [filter]="true"
        [placeholder]="'editCourrier.select' | translate"
        [showClear]="true"
        formControlName="langueID">
      </p-dropdown>
    </div>
  </form>
</p-dialog>

<p-dialog styleClass="super-compos-modal-content" [(visible)]="showCreateStreet" [modal]="true" appendTo="body" [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'editCourrier.streetManagement' | translate }}</h5>
      <div class="d-flex">
        <i-button styleClass="blue" (click)="showCreateStreet = false" [text]="'cancel' | translate"></i-button>
        <i-button styleClass="green ms-3" [disabled]="!formStreet.valid" (click)="submitNewStreet()" text="Confirmer"></i-button>
      </div>
    </div>
  </p-header>
  <form [formGroup]="formStreet" class="mt-3 mb-3 row">
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'editCourrier.street' | translate }}</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: Rue des belles vignes' }"
        [type]="'text'"
        [control]="formStreet.get('rue')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'editCourrier.addressPostalCode' | translate }}*</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: 4000' }"
        [type]="'text'"
        [control]="formStreet.get('codePostal')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'editCourrier.streetCode' | translate }}</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: 1' }"
        [type]="'text'"
        [control]="formStreet.get('codeRue')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'editCourrier.languageCode' | translate }}</label>
      <i-input
        [iInput]="{ placeholder: 'Ex: FR' }"
        [type]="'text'"
        [control]="formStreet.get('codeLangue')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
  </form>
</p-dialog>

<p-dialog styleClass="super-compos-modal-content" [(visible)]="showCreateContactType" [modal]="true" appendTo="body" [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'editCourrier.contactTypeManagement' | translate }}</h5>
      <div class="d-flex">
        <i-button styleClass="blue me-3" [text]="'cancel' | translate" (click)="showCreateContactType = false"></i-button>
        <i-button styleClass="green" (click)="submitNewContactType()" text="Confirmer"></i-button>
      </div>
    </div>
  </p-header>
  <form [formGroup]="formContactType" class="mt-3 row">
    <div class="col-md-12 mb-3">
      <label class="super-compos-label-input"> {{ 'editCourrier.locked' | translate }} </label>
      <p-inputSwitch formControlName="verrouille"></p-inputSwitch>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'editCourrier.description' | translate }}*</label>
      <i-input
        [iInput]="{ placeholder: 'editCourrier.descriptionContact' | translate }"
        [type]="'text'"
        [control]="formContactType.get('typeContact')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'editCourrier.sortingOrder' | translate }}</label>
      <i-input
        [iInput]="{ placeholder: 'editCourrier.descriptionOrder' | translate }"
        [type]="'text'"
        [control]="formContactType.get('ordreTri')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'editCourrier.filterContactsByType' | translate }}</label>
      <p-dropdown
        styleClass="w-100"
        [virtualScroll]="true"
        virtualScrollItemSize="30"
        appendTo="body"
        [options]="typesLV | sort: 'label' : 'ASC'"
        [filter]="true"
        [placeholder]="'editCourrier.select' | translate"
        [showClear]="true"
        (onChange)="filterContact($event)">
      </p-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'editCourrier.typeLinkedTo' | translate }}</label>
      <p-dropdown
        styleClass="w-100"
        [virtualScroll]="true"
        virtualScrollItemSize="30"
        appendTo="body"
        [options]="contactsLinked"
        [filter]="true"
        [placeholder]="'editCourrier.select' | translate"
        [showClear]="true"
        formControlName="carnetContactID">
      </p-dropdown>
    </div>
    <!-- <div class="col-md-6 mb-3">
        <label class="super-compos-label-input">{{ 'editCourrier.creationAllowedBy' | translate }}</label>
        <p-dropdown
          styleClass="w-100"
          [virtualScroll]="true"
          virtualScrollItemSize="30"
          appendTo="body"
          [options]="groups | sort: 'label' : 'ASC'"
          [filter]="true"
          [placeholder]="'editCourrier.select' | translate"
          [showClear]="true"
          formControlName="creationGereeParGroupeID">
        </p-dropdown>
      </div>
      <div class="col-md-6 mb-3">
        <label class="super-compos-label-input">{{ 'editCourrier.creationAllowedBy' | translate }}</label>
        <p-dropdown
          styleClass="w-100"
          [virtualScroll]="true"
          virtualScrollItemSize="30"
          appendTo="body"
          [options]="groups | sort: 'label' : 'ASC'"
          [filter]="true"
          [placeholder]="'editCourrier.select' | translate"
          [showClear]="true"
          formControlName="modificationGereeParGroupeId">
        </p-dropdown>
      </div>
      <div class="col-md-6 mb-3">
        <label class="super-compos-label-input">{{ 'editCourrier.modificationAllowedBy' | translate }}</label>
        <p-dropdown
          styleClass="w-100"
          [virtualScroll]="true"
          virtualScrollItemSize="30"
          appendTo="body"
          [options]="groups | sort: 'label' : 'ASC'"
          [filter]="true"
          [placeholder]="'editCourrier.select' | translate"
          [showClear]="true"
          formControlName="suppressionGereeParGroupeId">
        </p-dropdown>
      </div>
      <div class="col-md-6 mb-3">
        <label class="super-compos-label-input">{{ 'editCourrier.deletionAllowedBy' | translate }}</label>
        <p-dropdown
          styleClass="w-100"
          [virtualScroll]="true"
          virtualScrollItemSize="30"
          appendTo="body"
          [options]="groups | sort: 'label' : 'ASC'"
          [filter]="true"
          [placeholder]="'editCourrier.select' | translate"
          [showClear]="true"
          formControlName="visualisationGereeParGroupeID">
        </p-dropdown>
      </div> -->
  </form>
</p-dialog>
